import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import router from './router';
import store from '@/store';
import ApiService from '@/common/api.service';
import VueProgressBar from 'vue-progressbar';
import '@fortawesome/fontawesome-pro/css/all.css';
import VueMask from 'v-mask'

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueMask);
ApiService.init();

Vue.use(VueProgressBar, {
  color: '#00FF3A',
  failedColor: '#EA1E1E',
  height: '1px',
  thickness: '1px',
  transition: {
    speed: '0.5s',
    opacity: '0.2s',
    termination: 600,
  },
});

new Vue({
  router,
  store,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg',
    },
  }),
  render: createEle => createEle(App),
}).$mount('#app');
